import React from 'react';

// PLACEHOLDER: Vervang projecten-aantal door echt cijfer voor je live gaat
const stats = [
  { value: '30+', label: 'Projecten opgeleverd' },
  { value: '30', label: 'Dagen tot live' },
  { value: '100%', label: 'Vaste prijs, geen verrassingen' },
];

const StatsStrip: React.FC = () => {
  return (
    <section className="container mx-auto px-8 pt-12">
      <div className="bg-white rounded-2xl shadow-md p-6 sm:p-8 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center">
            <div
              className="text-4xl sm:text-5xl font-bold mb-1"
              style={{
                background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {stat.value}
            </div>
            <div className="text-sm sm:text-base text-gray-700 font-medium">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsStrip;
